// extracted by mini-css-extract-plugin
module.exports = {"cls1":"HomePage-CssProp9_td-module--cls1--3u1AZ","cls2":"HomePage-CssProp9_td-module--cls2--238eP HomePage-CssProp9_td-module--cls1--3u1AZ"};